import React, { useEffect, useRef } from 'react';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Button from '@mui/material/Button'

import LocationIcon from '@mui/icons-material/LocationOn';
import Pin_Disposal from '../../images/Icon_Disposal.png'
import Pin_HealthClinic from '../../images/Icon_HealthClinic.png'
import Pin_HIV from '../../images/Icon_HIV.png'
import Pin_Pharmacy from '../../images/Icon_Pharmacy.png'
import Pin_Recovery from '../../images/Icon_Recovery.png'
import Pin_Syringe from '../../images/Icon_Syringe.png'
import { Typography } from '@material-ui/core';

const CategorySelection = ({ type, setType, mapWidth }) => {

  const handleFormat = (event, newType) => {
    setType(newType)
  };

  const iconStyle = {
    width: 30,
    height: 30
  };
  const iconStyle_Large = {
    width: 40,
    height: 40
  };
  const iconStyleAll = {
    width: 30,
    height: 30,
    color: 'orangered'
  };
  const iconStyleAll_Large = {
    width: 40,
    height: 40,
    color: 'orangered'
  };

  return (
    <div style={{
      flexDirection: 'column',
      alignSelf: 'center',
      alignItems: 'center',
    }}>
        <div style={{
          alignItems: 'center',
          textAlign: 'center',
        }}>
          <Button variant="contained" color="secondary" style={{
            marginBottom: 4,
          }}>
              {type}
          </Button>
        </div>
        <div>
          <ToggleButtonGroup
              value={type}
              exclusive
              onChange={handleFormat}
              aria-label="current category"
              size="small"
              style={{backgroundColor: 'lightgray'}}
          >
          <ToggleButton value="View All" aria-label="View All">
              <LocationIcon style={(type == "View All" ? iconStyleAll_Large : iconStyleAll)} />
          </ToggleButton>
          <ToggleButton value="Pharmacy" aria-label="Pharmacy">
              <img style={(type == "Pharmacy" ? iconStyle_Large : iconStyle)} src={Pin_Pharmacy} />
          </ToggleButton>
          <ToggleButton value="Substance Use Disorder Treatment" aria-label="Substance Use Disorder Treatment">
              <img style={(type == "Substance Use Disorder Treatment" ? iconStyle_Large : iconStyle)} src={Pin_Recovery} />
          </ToggleButton>
          <ToggleButton value="Sharps Disposal" aria-label="Sharps Disposal">
              <img style={(type == "Sharps Disposal" ? iconStyle_Large : iconStyle)} src={Pin_Disposal} />
          </ToggleButton>
          <ToggleButton value="Health Clinic" aria-label="Health Clinic">
              <img style={(type == "Health Clinic" ? iconStyle_Large : iconStyle)} src={Pin_HealthClinic} />
          </ToggleButton>
          <ToggleButton value="HIV Services" aria-label="HIV Services">
              <img style={(type == "HIV Services" ? iconStyle_Large : iconStyle)} src={Pin_HIV} />
          </ToggleButton>
          <ToggleButton value="Syringe Exchange" aria-label="Syringe Exchange">
              <img style={(type == "Syringe Exchange" ? iconStyle_Large : iconStyle)} src={Pin_Syringe} />
          </ToggleButton>
          </ToggleButtonGroup>
        </div>
    </div>
  );
}

export default CategorySelection